import { Tab } from "@headlessui/react";
import styled from "styled-components";

import { colourScheme } from "utils/styling/colours";

export const TabsContainer = styled.div`
    width: 100%;
    flex: 2;
`;

export const TabList = styled(Tab.List)`
    display: flex;
    border-bottom: 1px solid ${colourScheme.secondary};
`;

export const TabButton = styled(Tab)`
    padding: 1rem 2rem;
    cursor: pointer;
    border: none;
    background: none;
    font-size: 1rem;
    transition: all 0.3s ease;
    color: ${colourScheme.white};

    &:hover {
        background-color: ${colourScheme.primaryDark};
    }

    &[aria-selected="true"] {
        border-bottom: 6px solid ${colourScheme.secondary};
        color: ${colourScheme.white};
        background-color: ${colourScheme.primary};
    }
`;

export const TabPanel = styled(Tab.Panel)`
    padding: 1rem;
    overflow-y: auto;
    max-height: 80vh;
`;
